import React, { useContext, useEffect, useState } from "react";
import "./index.css";
import { AtendentesContext } from "../../../contexts/AtendentesContext";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import caAPI from "../../../services/caAPI";
import { AtendimentoContext } from "../../../contexts/AtendimentoContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faUsers } from "@fortawesome/free-solid-svg-icons";
import ModalDommus from "../../../components/Modal";
import { ConteudoAtendentesModal } from "./ConteudoAtendentesModal";
import stringHelper from "../../../helpers/StringHelper";
import { BrowserView, isMobile, MobileView } from "react-device-detect";
import { usePromiseTracker } from "react-promise-tracker";

const componenteCarregamento =
  (
    <>
      <div className="icone-atendente skeleton-animation"></div>
      <div className="icone-atendente skeleton-animation"></div>
      <div className="icone-atendente skeleton-animation"></div>
      <div className="icone-atendente skeleton-animation"></div>
      <div className="icone-atendente skeleton-animation"></div>
    </>
  )
export function AtendentesSection(){
  const [openModal, setOpenModal] = useState(false);
  const {listaAtendentes} = useContext(AtendentesContext);
  const [atendentesFormatados, setAtendentesFormatados] = useState(listaAtendentes);
  const {atendentesSelecionados, setAtendentesSelecionados, setTipoAtendimentoSelecionado, setMarcadoresSelecionados, handleExecutaPesquisaTelaPrincipal} = useContext(AtendimentoContext);
  const {promiseInProgress: isLoadingAtendentes} = usePromiseTracker({area: "loading-atendentes"});
  
  useEffect(()=>{
    setAtendentesFormatados(listaAtendentes);
  },[listaAtendentes])

  const handleSelecionarCorretor = (atendente) => {
    var atendentes = atendentesSelecionados;

    if(atendentes.includes(Number(atendente.id))){
      atendentes = atendentes.filter((item) => Number(item) !== Number(atendente.id))
    }else{
      atendentes = [...atendentes, Number(atendente.id)]
    }

    const filtros = JSON.parse(caAPI.getLocalState('filtros'));
    filtros.atendente = atendentesFormatados.filter((item) => atendentes.includes(Number(item.id))).map((item) => {return {value: item.id, label: item.nome}});
    delete filtros.tipo_atendimento;
    handleExecutaPesquisaTelaPrincipal(filtros);

    var selecionadosTemp = atendentesFormatados.filter((item) => atendentes.includes(Number(item.id))).sort((a, b) => a.nome > b.nome ? 1 : -1);
    var atendentesRemovidos = atendentesFormatados.filter((item) => !atendentes.includes(Number(item.id))).sort((a, b) => a.nome > b.nome ? 1 : -1);
    setAtendentesFormatados([...selecionadosTemp, ...atendentesRemovidos]);

    setMarcadoresSelecionados([]);
    setAtendentesSelecionados(atendentes);
    setTipoAtendimentoSelecionado(null)
  }

  return (
    <>
      <BrowserView>
        <div className="atendentes-section">
          {isLoadingAtendentes ? 
            componenteCarregamento
          : atendentesFormatados.length ? atendentesFormatados.slice(0, 5).map((item, index)=>{
            const itemSelecionado = atendentesSelecionados.includes(Number(item.id));
            return (
                <OverlayTrigger
                    key={`tooltip-atendente-${index}`}
                    placement="top"
                    overlay={
                        <Tooltip id={`tooltip-atendente-${index}`}>
                            {item?.nome}
                        </Tooltip>
                    }
                >
                  <div 
                    className={`icone-atendente ${ itemSelecionado ? "selecionado" : ""}`}
                    style={{backgroundColor: itemSelecionado ? item.cor : "white", color: item.cor, borderColor: `${item.cor}`}}
                    onClick={()=>{
                      handleSelecionarCorretor(item);
                    }}
                  >
                    {stringHelper.resolverIconeAtendente(item.nome)}
                  </div>
                </OverlayTrigger>    
            )
          }) :  <></>}
          {atendentesFormatados?.length > 7 ? 
            <OverlayTrigger
                key={`tooltip-abrir-atendente`}
                placement="top"
                overlay={
                    <Tooltip id={`tooltip-abrir-atendente`}>
                        Abrir lista de atendentes
                    </Tooltip>
                }
            >
              <div 
                className={`icone-atendente abrir-atendentes`}
                onClick={()=>{
                  setOpenModal(true)
                }}
              >
                {atendentesSelecionados.length > 7 ? <div className="indicador-atendentes">{atendentesSelecionados?.length - 7}</div> : <></>}
                <FontAwesomeIcon icon={faPlus}/>
              </div>
            </OverlayTrigger>
            :
            <></>
          }
        </div>
      </BrowserView>
      {isMobile ? 
        <div className="atendentes-section">
          <div 
            className={`icone-atendente abrir-atendentes`}
            onClick={()=>{
              setOpenModal(true)
            }}
          >
            {atendentesSelecionados.length > 0 ? <div className="indicador-atendentes">{atendentesSelecionados?.length}</div> : <></>}
            <FontAwesomeIcon icon={faUsers}/>
          </div>
        </div>
      : <></>}
      <ModalDommus
        open={openModal}
        close={() => {
          setOpenModal(false);
        }}
        size="md"
        titulo="Atendentes"
      >
        <ConteudoAtendentesModal 
          atendentes={atendentesFormatados} 
          handleSelecionarCorretor={handleSelecionarCorretor}
        />
      </ModalDommus>
    </>
  )
}
